import { Box } from 'konva/lib/shapes/Transformer'
import { Vector2d } from 'konva/lib/types'


export const getRealPosition = (box: Box): Vector2d => {
    if (box.rotation === 0 || box.rotation % 90 !== 0)
        return { x: box.x, y: box.y }

    if (box.rotation === 90 || box.rotation === -270)
        return { x: box.x - box.height - ((box.width - box.height) / 2), y: box.y - ((box.height - box.width) / 2) }

    if (box.rotation === 180 || box.rotation === -180)
        return { x: box.x - box.width, y: box.y - box.height }

    if (box.rotation === 270 || box.rotation === -90)
        return { x: box.x - ((box.width - box.height) / 2), y: box.y - box.width - ((box.height - box.width) / 2) }

    return { x: box.x, y: box.y }
}


export const getZeroRotatedBox = (box: Box): Box => {
    if (box.rotation === 0 || box.rotation % 90 !== 0)
        return { ...box }

    if (box.rotation === 90 || box.rotation === -270)
        return {
            x: box.x - box.height - ((box.width - box.height)),
            y: box.y,
            width: box.height,
            height: box.width,
            rotation: 0,
        }

    if (box.rotation === 180 || box.rotation === -180)
        return {
            ...box,
            x: -box.x - box.width,
            y: box.y - box.height,
            rotation: 0,
        }

    if (box.rotation === 270 || box.rotation === -90)
        return {
            x: box.x,
            y: box.y - box.width - ((box.height - box.width)),
            width: box.height,
            height: box.width,
            rotation: 0,
        }

    return { ...box }
}
